import Block from '@/components/Block'
import IcoMoon from '@/components/IcoMoon'
import { Stack } from '@/components/Layout'
import Text from '@/components/Text'
import { coreLayoutContainer, coreLayoutSection, UnitSize } from '@/constants/measured-scope'
import * as React from 'react'
import { useMemo, useRef } from 'react'
import RSSlider from 'react-slick'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import * as styles from './style'

type CarouselOptions = false | UnitSize[] | 'always'

export interface CardRowProps {
  title?: string | null
  subtitle?: string | null
  carousel?: CarouselOptions
  spacing?: UnitSize
  // Callback to parent with page to load if applicable
  className?: string
  children: React.ReactNode[]
}

export type DeviceSizes = {
  [key in UnitSize]: boolean | undefined
}

const VideoCarousel = ({ title, subtitle, children }: CardRowProps): JSX.Element => {
  const rsSliderRef = useRef<any>(null)

  const carouselArrowLeft = useMemo(() => {
    const prev = (): void => {
      if (rsSliderRef.current && rsSliderRef.current.slickPrev) {
        rsSliderRef.current.slickPrev()
      }
    }
    return (
      <a className={`${styles.rowArrowLeft} mr-xxs`} onClick={prev}>
        <IcoMoon icon="chevron-left" />
      </a>
    )
  }, [])

  const carouselArrowRight = useMemo(() => {
    const next = (): void => {
      if (rsSliderRef.current && rsSliderRef.current.slickNext) {
        rsSliderRef.current.slickNext()
      }
    }
    return (
      <a className={styles.rowArrowRight} onClick={next}>
        <IcoMoon icon="chevron-right" />
      </a>
    )
  }, [])

  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: false,
    arrows: false,
    responsive: undefined,
  }

  return (
    <Block className={`${coreLayoutSection} ${styles.root}`}>
      <Stack className={coreLayoutContainer}>
        <Stack alignItems="center" x>
          {title && (
            <Text tag="h2" weight="lg" size="lg" responsiveSize={{ xl: 'xl' }}>
              {title}
            </Text>
          )}
        </Stack>
        {subtitle && (
          <Text tag="p" size="xs" weight="sm" className="fc-grey">
            {subtitle}
          </Text>
        )}
        <RSSlider
          {...sliderSettings}
          ref={rsSliderRef}
          className="pt-xxs pb-sm pt-xs-gte-sm pb-lg-gte-sm pt-sm-gte-lg pt-md-gte-xl"
        >
          {children.map((card, key) => (
            <Stack className="flex-center navArrows" justifyContent="center">
              {carouselArrowLeft}
              <div key={key}>{card}</div>
              {carouselArrowRight}
            </Stack>
          ))}
        </RSSlider>
      </Stack>
    </Block>
  )
}

export default VideoCarousel
